class CodeParachuteFooter {
    constructor(footer) {
        this.footer = footer
        this.init()
    }
    
    init() {
        const footerSocialMenu = this.footer.querySelector('.footer-social-menu')
        if (footerSocialMenu) {
            const menuItems = footerSocialMenu.querySelectorAll('.menu-item')
            for (let i = 0; i < menuItems.length; i++) {
                const menuItem = menuItems[i]
                const menuItemLink = menuItem.querySelector('a')
                menuItem.addEventListener('click', () => {
                    menuItemLink.click()
                })
            }
        }
        const backTopTopButton = this.footer.querySelector('.back-to-top-button')
        if (backTopTopButton) {
            backTopTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            })
        }
    }
}

document.querySelectorAll('.codeparachute-footer').forEach((footer) => new CodeParachuteFooter(footer))